module.exports = __webpack_public_path__ + "img/programs.a27ad355.svg";